export const isDevelopment = process.env.isDevelopment;
export const EP_WEBSITE_TERMS_CONDITIONS_BASE_URL =
  process.env.REACT_APP_EP_WEBSITE_TERMS_CONDITIONS_BASE_URL;
export const EP_WEBSITE_PRIVACY_POLICY_BASE_URL =
  process.env.REACT_APP_EP_WEBSITE_PRIVACY_POLICY_BASE_URL;
export const REACT_APP_PARTNER_WEBSITE_URL = process.env.REACT_APP_PARTNER_WEBSITE_URL;
export const REACT_APP_FLASHES_SERVER_LESS_API_BASE_URL =
  process.env.REACT_APP_FLASHES_SERVER_LESS_API_BASE_URL;

export const allTabRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 1,
    label: "Devices",
    activeRoutes: [
      "/admin/all/devices",
      "/admin/devices/view/:id",
      "/admin/device/view/firmware-history/:id",
      "/admin/device/view/impulse-rate-history/:id",
      "/admin/device/view/device-history/:id",

      "/admin/livelink/devices/view/:id",
      "/admin/airlink/device/view/:id",
      "/admin/safelink/device/view/:id",
      "/admin/bulb/device/view/:id",
      "/admin/bulb/device/view/device-history/:serial_number",
    ],
    url: "/admin/all/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
      "/admin/customer/auto-sync/:id",
    ],
    url: "/admin/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },
];

export const adminRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: [
      "/admin/electricity-advisor/devices",
      "/admin/devices/view/:id",
      "/admin/device/view/firmware-history/:id",
      "/admin/device/view/impulse-rate-history/:id",
      "/admin/device/view/device-history/:id",
    ],
    url: "/admin/electricity-advisor/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  {
    id: 3,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
      "/admin/customer/auto-sync/:id",
    ],
    url: "/admin/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },

  {
    id: 4,
    label: "Manage Agencies",
    activeRoutes: [
      "/admin/installer-agencies",
      "/admin/installer-agency",
      "/admin/installer-agency/view/:id",
      "/admin/installer-agency/:id",
      "/admin/integration/view/:id",
      "/admin/integrations",
    ],
    url: "/admin/installer-agencies",
    Icon: "/images/Manage-Agencies-icon.svg",
    activeIcon: "/images/Manage-Agencies-icon1.svg",
    collapse: true,
    subList: [
      {
        label: "Integrations",
        activeRoutes: ["/admin/integrations", "/admin/integration/view/:id"],
        url: "/admin/integrations",
        collapse: false,
        subIcon: "/images/team-line.svg",
        activeIcon: "/images/team-line(1).svg",
      },
      {
        label: "Agencies",
        activeRoutes: [
          "/admin/installer-agencies",
          "/admin/installer-agency/view/:id",
          "/admin/installer-agency",
          "/admin/installer-agency/:id",
        ],
        url: "/admin/installer-agencies",
        subIcon: "/images/building-2-line.svg",
        activeIcon: "/images/building-2(1).svg",
        collapse: false,
      },
    ],
  },

  {
    id: 5,
    label: "Manage Electricians",
    activeRoutes: [
      "/admin/electricians",
      "/admin/electrician/view/:id",
      "/admin/electrician",
      "/admin/electrician/:id",
      "/admin/electricians-installers",
      "/admin/electrician-installer/view/:id",
      "/admin/aggregators",
      "/admin/electrician-installer/device/view/:id",
    ],
    Icon: "/images/Manage-Electricians.svg",
    activeIcon: "/images/Manage-Electricians1.svg",
    collapse: true,
    subList: [
      {
        label: "Aggregators",
        activeRoutes: ["/admin/aggregators"],
        url: "/admin/aggregators",
        subIcon: "/images/Agreegators.svg",
        activeIcon: "/images/Agreegators1.svg",
        collapse: false,
      },
      {
        label: "Electricians",
        activeRoutes: [
          "/admin/electricians",
          "/admin/electrician/view/:id",
          "/admin/electrician",
          "/admin/electrician/:id",
        ],
        url: "/admin/electricians",
        collapse: false,
        subIcon: "/images/Electrician.svg",
        activeIcon: "/images/Electrician1.svg",
      },
      {
        label: "Field Workers",
        activeRoutes: [
          "/admin/electricians-installers",
          "/admin/electrician-installer/view/:id",
          "/admin/electrician-installer/device/view/:id",
        ],
        url: "/admin/electricians-installers",
        subIcon: "/images/ElecInstallers.svg",
        activeIcon: "/images/ElecInstallers1.svg",
        collapse: false,
      },
    ],
  },

  {
    id: 6,
    label: "Installer Agents",
    activeRoutes: [
      "/admin/installer-agents",
      "/admin/installer-agent/view/:id",
      "/admin/installer-agent/view/device/:id",
    ],
    url: "/admin/installer-agents",
    Icon: "/images/Installer-Agents-icon.svg",
    activeIcon: "/images/Installer-Agents-icon1.svg",
    collapse: false,
  },

  {
    id: 7,
    label: "Tariffs",
    activeRoutes: ["/admin/tariffs", "/admin/tariff", "/admin/tariff/:id"],
    url: "/admin/tariffs",
    Icon: "/images/Tariffs.svg",
    activeIcon: "/images/Tariffs1.svg",
    collapse: false,
  },

  {
    id: 8,
    label: "Electricity Retailers",
    activeRoutes: ["/admin/electricity-retailers"],
    url: "/admin/electricity-retailers",
    Icon: "/images/Electricity-Retailers.svg",
    activeIcon: "/images/Electricity-Retailers1.svg",
    collapse: false,
  },

  {
    id: 9,
    label: "Manage Firmwares",
    activeRoutes: [
      "/admin/firmwares",
      "/admin/OTAs",
      "/admin/OTA_History",
      "/admin/rules",
      "/admin/OTA-groups",
      "/admin/OTA-groups/:id",
    ],
    url: "/admin/firmwares",
    Icon: "/images/Manage-Firmwares.svg",
    activeIcon: "/images/Manage-Firmwares1.svg",
    collapse: true,
    subList: [
      {
        label: "Firmwares",
        activeRoutes: ["/admin/firmwares"],
        url: "/admin/firmwares",
        subIcon: "/images/code-box-line.svg",
        activeIcon: "/images/code-box-line-(1).svg",
        collapse: false,
      },
      {
        label: "OTA",
        activeRoutes: ["/admin/OTAs"],
        url: "/admin/OTAs",
        subIcon: "/images/device-recover-line.svg",
        activeIcon: "/images/device-recover-line(1).svg",
        collapse: false,
      },
      {
        label: "OTA History",
        activeRoutes: ["/admin/OTA_History"],
        url: "/admin/OTA_History",
        subIcon: "/images/history-line.svg",
        activeIcon: "/images/history-line-(1).svg",
        collapse: false,
      },
      {
        label: "Rules",
        activeRoutes: ["/admin/rules"],
        url: "/admin/rules",
        subIcon: "/images/file-list-line.svg",
        activeIcon: "/images/file-list-line(1).svg",
        collapse: false,
      },
      {
        label: "Groups",
        activeRoutes: ["/admin/OTA-groups", "/admin/OTA-groups/:id"],
        url: "/admin/OTA-groups",
        subIcon: "/images/group-2-line.svg",
        activeIcon: "/images/group-2-line-(1).svg",
        collapse: false,
      },
    ],
  },

  {
    id: 10,
    label: "Suppression List",
    activeRoutes: ["/admin/weekly-reports"],
    url: "/admin/weekly-reports",
    Icon: "/images/weekly-reports-disable.svg",
    activeIcon: "/images/weekly reports enable.svg",
    collapse: false,
  },
  {
    id: 11,
    label: "Slider",
    activeRoutes: ["/admin/electricity-advisor/slider"],
    url: "/admin/electricity-advisor/slider",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
];

export const lightningRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: [
      "/admin/bulb/devices",
      "/admin/devices/view/:id",
      "/admin/device/view/firmware-history/:id",
      "/admin/device/view/impulse-rate-history/:id",
      "/admin/device/view/device-history/:id",
      "/admin/bulb/device/view/:id",
    ],
    url: "/admin/bulb/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  {
    id: 3,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
      "/admin/customer/auto-sync/:id",
    ],
    url: "/admin/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },
  {
    id: 7,
    label: "Tariffs",
    activeRoutes: ["/admin/tariffs", "/admin/tariff", "/admin/tariff/:id"],
    url: "/admin/tariffs",
    Icon: "/images/Tariffs.svg",
    activeIcon: "/images/Tariffs1.svg",
    collapse: false,
  },

  // {
  //   id: 8,
  //   label: 'Electricity Retailers',
  //   activeRoutes: ['/admin/electricity-retailers'],
  //   url: '/admin/electricity-retailers',
  //   Icon: '/images/Electricity-Retailers.svg',
  //   activeIcon: '/images/Electricity-Retailers1.svg',
  //   collapse: false
  // },

  {
    id: 9,
    label: "Manage Firmwares",
    activeRoutes: [
      "/admin/firmwares",
      "/admin/OTAs",
      "/admin/OTA_History",
      "/admin/rules",
      "/admin/OTA-groups",
      "/admin/OTA-groups/:id",
    ],
    url: "/admin/firmwares",
    Icon: "/images/Manage-Firmwares.svg",
    activeIcon: "/images/Manage-Firmwares1.svg",
    collapse: true,
    subList: [
      {
        label: "Firmwares",
        activeRoutes: ["/admin/firmwares"],
        url: "/admin/firmwares",
        subIcon: "/images/code-box-line.svg",
        activeIcon: "/images/code-box-line-(1).svg",
        collapse: false,
      },
      {
        label: "OTA",
        activeRoutes: ["/admin/OTAs"],
        url: "/admin/OTAs",
        subIcon: "/images/device-recover-line.svg",
        activeIcon: "/images/device-recover-line(1).svg",
        collapse: false,
      },
      {
        label: "OTA History",
        activeRoutes: ["/admin/OTA_History"],
        url: "/admin/OTA_History",
        subIcon: "/images/history-line.svg",
        activeIcon: "/images/history-line-(1).svg",
        collapse: false,
      },
      {
        label: "Rules",
        activeRoutes: ["/admin/rules"],
        url: "/admin/rules",
        subIcon: "/images/file-list-line.svg",
        activeIcon: "/images/file-list-line(1).svg",
        collapse: false,
      },
      {
        label: "Groups",
        activeRoutes: ["/admin/OTA-groups", "/admin/OTA-groups/:id"],
        url: "/admin/OTA-groups",
        subIcon: "/images/group-2-line.svg",
        activeIcon: "/images/group-2-line-(1).svg",
        collapse: false,
      },
    ],
  },

  {
    id: 10,
    label: "Suppression List",
    activeRoutes: ["/admin/weekly-reports"],
    url: "/admin/weekly-reports",
    Icon: "/images/weekly-reports-disable.svg",
    activeIcon: "/images/weekly reports enable.svg",
    collapse: false,
  },
];

export const userRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/user/dashboard"],
    url: "/user/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
];

export const customerRoutes = [
  {
    id: 1,
    label: "Devices",
    activeRoutes: ["/customer/devices", "/customer/devices/view/:id"],
    url: "/customer/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
];

export const heatPumpRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: [
      "/admin/heat_pump/devices",
      "/admin/devices/view/:id",
      "/admin/device/view/firmware-history/:id",
      "/admin/device/view/impulse-rate-history/:id",
      "/admin/device/view/device-history/:id",
      "/admin/heat_pump/device/view/:id",
    ],
    url: "/admin/heat_pump/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  {
    id: 3,
    label: "Manage Multi Site..",
    activeRoutes: [
      "/admin/heat_pump/sites",
      "/admin/heat_pump/multi-site-company",
      "/admin/heat_pump/sites/view/:id",
      "/admin/heat_pump/multi-site-company/view/:id",
    ],
    url: "/admin/heat_pump/multi-site-company",
    Icon: "/images/Multisite-icon.svg",
    activeIcon: "/images/Multisite-active-icon.svg",
    collapse: true,
    subList: [
      {
        label: "Multi Site Companies",
        activeRoutes: [
          "/admin/heat_pump/multi-site-company",
          "/admin/heat_pump/sites/view/:id",
          "/admin/heat_pump/multi-site-company/view/:id",
        ],
        url: "/admin/heat_pump/multi-site-company",
        collapse: false,
        subIcon: "/images/multi-site-companies.svg",
        activeIcon: "/images/multi-site-companies.svg",
      },
      {
        label: "Sites",
        activeRoutes: ["/admin/heat_pump/sites"],
        url: "/admin/heat_pump/sites",
        collapse: false,
        subIcon: "/images/Sites-icon.svg",
        activeIcon: "/images/Sites-active-icon.svg",
      },
      // {
      //   label: 'Properties',
      //   activeRoutes: [
      //     '/admin/installer-agencies',
      //     '/admin/installer-agency/view/:id',
      //     '/admin/installer-agency',
      //     '/admin/installer-agency/:id'
      //   ],
      //   url: '/admin/installer-agencies',
      //   subIcon: '/images/Property-icon.svg',
      //   activeIcon: '/images/Property-active-icon.svg',
      //   collapse: false
      // }
    ],
  },
  {
    id: 4,
    label: "Attention",
    url: "/admin/heat_pump/faulty-systems",
    activeRoutes: [
      "/admin/heat_pump/faulty-systems",
      "/admin/heat_pump/faulty-systems/view/faulty-history/:id",
    ],
    Icon: "/images/faultysystem.png",
    divider: true,
    activeIcon: "/images/faultysystem.svg",
    faultIcon: "/images/faulty-alert-system.svg",
    collapse: false,
  },
  {
    id: 8,
    label: "Manage Agencies",
    activeRoutes: [
      "/admin/installer-agencies",
      "/admin/installer-agency",
      "/admin/installer-agency/view/:id",
      "/admin/installer-agency/:id",
      "/admin/integration/view/:id",
      "/admin/integrations",
    ],
    url: "/admin/installer-agencies",
    Icon: "/images/Manage-Agencies-icon.svg",
    activeIcon: "/images/Manage-Agencies-icon1.svg",
    collapse: true,
    subList: [
      {
        label: "Integrations",
        activeRoutes: ["/admin/integrations", "/admin/integration/view/:id"],
        url: "/admin/integrations",
        collapse: false,
        subIcon: "/images/team-line.svg",
        activeIcon: "/images/team-line(1).svg",
      },
      {
        label: "Agencies",
        activeRoutes: [
          "/admin/installer-agencies",
          "/admin/installer-agency/view/:id",
          "/admin/installer-agency",
          "/admin/installer-agency/:id",
        ],
        url: "/admin/installer-agencies",
        subIcon: "/images/building-2-line.svg",
        activeIcon: "/images/building-2(1).svg",
        collapse: false,
      },
    ],
  },
  {
    id: 9,
    label: "Installer Agents",
    activeRoutes: [
      "/admin/installer-agents",
      "/admin/installer-agent/view/:id",
      "/admin/installer-agent/view/device/:id",
    ],
    url: "/admin/installer-agents",
    Icon: "/images/Installer-Agents-icon.svg",
    activeIcon: "/images/Installer-Agents-icon1.svg",
    collapse: false,
  },

  {
    id: 6,
    label: "Multi Site Contacts",
    activeRoutes: ["/admin/heat_pump/multi-site-contacts"],
    url: "/admin/heat_pump/multi-site-contacts",
    Icon: "/images/multi-site-contacts.svg",
    activeIcon: "/images/multi-site-contacts.svg",
  },
  {
    id: 7,
    label: "Site Managers",
    activeRoutes: ["/admin/heat_pump/site-managers"],
    url: "/admin/heat_pump/site-managers",
    Icon: "/images/site-manager.svg",
    activeIcon: "/images/site-manager.svg",
  },
  {
    id: 5,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
      "/admin/customer/auto-sync/:id",
    ],
    url: "/admin/customers",
    divider: true,
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },

  {
    id: 11,
    label: "Models",
    activeRoutes: ["/admin/heat_pump/models"],
    url: "/admin/heat_pump/models",
    Icon: "/images/Electricity-Retailers.svg",
    activeIcon: "/images/Electricity-Retailers1.svg",
    collapse: false,
  },

  {
    id: 12,
    label: "Manage Firmwares",
    activeRoutes: [
      "/admin/firmwares",
      "/admin/OTAs",
      "/admin/OTA_History",
      "/admin/rules",
      "/admin/OTA-groups",
      "/admin/OTA-groups/:id",
    ],
    url: "/admin/firmwares",
    Icon: "/images/Manage-Firmwares.svg",
    activeIcon: "/images/Manage-Firmwares1.svg",
    collapse: true,
    subList: [
      {
        label: "Firmwares",
        activeRoutes: ["/admin/firmwares"],
        url: "/admin/firmwares",
        subIcon: "/images/code-box-line.svg",
        activeIcon: "/images/code-box-line-(1).svg",
        collapse: false,
      },
      {
        label: "OTA",
        activeRoutes: ["/admin/OTAs"],
        url: "/admin/OTAs",
        subIcon: "/images/device-recover-line.svg",
        activeIcon: "/images/device-recover-line(1).svg",
        collapse: false,
      },
      {
        label: "OTA History",
        activeRoutes: ["/admin/OTA_History"],
        url: "/admin/OTA_History",
        subIcon: "/images/history-line.svg",
        activeIcon: "/images/history-line-(1).svg",
        collapse: false,
      },
      {
        label: "Rules",
        activeRoutes: ["/admin/rules"],
        url: "/admin/rules",
        subIcon: "/images/file-list-line.svg",
        activeIcon: "/images/file-list-line(1).svg",
        collapse: false,
      },
      {
        label: "Groups",
        activeRoutes: ["/admin/OTA-groups", "/admin/OTA-groups/:id"],
        url: "/admin/OTA-groups",
        subIcon: "/images/group-2-line.svg",
        activeIcon: "/images/group-2-line-(1).svg",
        collapse: false,
      },
    ],
  },
  {
    id: 10,
    label: "Tariffs",
    activeRoutes: ["/admin/tariffs", "/admin/tariff", "/admin/tariff/:id"],
    url: "/admin/tariffs",
    Icon: "/images/Tariffs.svg",
    activeIcon: "/images/Tariffs1.svg",
    collapse: false,
  },
];

export const livelinkRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 1,
    label: "Devices",
    activeRoutes: [
      "/admin/livelink/devices",
      "/admin/livelink/devices/view/:id",
      "/admin/device/view/firmware-history/:id",
      "/admin/device/view/cloud-tool/:deviceId",
      "/admin/livelink/device/view/device-history/:id",
    ],
    url: "/admin/livelink/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
    ],
    url: "/admin/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },
  {
    id: 3,
    label: "Tariffs",
    activeRoutes: ["/admin/tariffs", "/admin/tariff", "/admin/tariff/:id"],
    url: "/admin/tariffs",
    Icon: "/images/Tariffs.svg",
    activeIcon: "/images/Tariffs1.svg",
    collapse: false,
  },
  {
    id: 6,
    label: "Electricity Retailers",
    activeRoutes: ["/admin/electricity-retailers"],
    url: "/admin/electricity-retailers",
    Icon: "/images/Electricity-Retailers.svg",
    activeIcon: "/images/Electricity-Retailers1.svg",
    collapse: false,
  },
  {
    id: 4,
    label: "Manage Firmwares",
    activeRoutes: [
      "/admin/firmwares",
      "/admin/OTAs",
      "/admin/OTA_History",
      "/admin/rules",
      "/admin/OTA-groups",
      "/admin/OTA-groups/:id",
    ],
    url: "/admin/firmwares",
    Icon: "/images/Manage-Firmwares.svg",
    activeIcon: "/images/Manage-Firmwares1.svg",
    collapse: true,
    subList: [
      // {
      //   label: 'Firmwares',
      //   activeRoutes: ['/admin/livelink/firmwares'],
      //   url: '/admin/livelink/firmwares',
      //   subIcon: '/images/code-box-line.svg',
      //   activeIcon: '/images/code-box-line-(1).svg',
      //   collapse: false
      // },
      {
        label: "Firmwares",
        activeRoutes: ["/admin/firmwares"],
        url: "/admin/firmwares",
        subIcon: "/images/code-box-line.svg",
        activeIcon: "/images/code-box-line-(1).svg",
        collapse: false,
      },
      {
        label: "OTA",
        activeRoutes: ["/admin/OTAs"],
        url: "/admin/OTAs",
        subIcon: "/images/device-recover-line.svg",
        activeIcon: "/images/device-recover-line(1).svg",
        collapse: false,
      },
      {
        label: "OTA History",
        activeRoutes: ["/admin/OTA_History"],
        url: "/admin/OTA_History",
        subIcon: "/images/history-line.svg",
        activeIcon: "/images/history-line-(1).svg",
        collapse: false,
      },
      {
        label: "Rules",
        activeRoutes: ["/admin/rules"],
        url: "/admin/rules",
        subIcon: "/images/file-list-line.svg",
        activeIcon: "/images/file-list-line(1).svg",
        collapse: false,
      },
      {
        label: "Groups",
        activeRoutes: ["/admin/OTA-groups", "/admin/OTA-groups/:id"],
        url: "/admin/OTA-groups",
        subIcon: "/images/group-2-line.svg",
        activeIcon: "/images/group-2-line-(1).svg",
        collapse: false,
      },
    ],
  },
  {
    id: 5,
    label: "Slider",
    activeRoutes: ["/admin/livelink/slider"],
    url: "/admin/livelink/slider",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
];

export const safelinkRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 9,
    label: "Devices",
    activeRoutes: [
      "/admin/safelink/devices",
      "/admin/safelink/device/view/:id",
      "/admin/safelink/device/view/device-history/:mac_address",
      "/admin/device/view/firmware-history/:id",
    ],
    url: "/admin/safelink/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  // {
  //   id: 4,
  //   label: 'Devices',
  //   activeRoutes: [
  //     '/admin/safelink/devices',
  //     '/admin/safelink/device/view/:id',
  //     '/admin/smoke-alarm/devices',
  //     '/admin/smoke-alarm/device/view/:id'
  //   ],
  //   url: '/admin/safelink/devices',
  //   Icon: '/images/Devices-icon.svg',
  //   activeIcon: '/images/Devices-icon1.svg',
  //   collapse: true,
  //   subList: [
  //     {
  //       label: 'Safelinks',
  //       activeRoutes: ['/admin/safelink/devices', '/admin/safelink/device/view/:id'],
  //       url: '/admin/safelink/devices',
  //       subIcon: '/images/code-box-line.svg',
  //       activeIcon: '/images/code-box-line-(1).svg',
  //       collapse: false
  //     },
  //     {
  //       label: 'Smoke Alarms',
  //       activeRoutes: ['/admin/smoke-alarm/devices', '/admin/smoke-alarm/device/view/:id'],
  //       url: '/admin/smoke-alarm/devices',
  //       subIcon: '/images/code-box-line.svg',
  //       activeIcon: '/images/code-box-line-(1).svg',
  //       collapse: false
  //     }
  //   ]
  // },
  {
    id: 2,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
    ],
    url: "/admin/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },
  {
    id: 4,
    label: "Manage Firmwares",
    activeRoutes: [
      "/admin/firmwares",
      "/admin/livelink/firmwares",
      "/admin/OTAs",
      "/admin/OTA_History",
      "/admin/rules",
      "/admin/OTA-groups",
      "/admin/OTA-groups/:id",
    ],
    url: "/admin/firmwares",
    Icon: "/images/Manage-Firmwares.svg",
    activeIcon: "/images/Manage-Firmwares1.svg",
    collapse: true,
    subList: [
      {
        label: "Firmwares",
        activeRoutes: ["/admin/firmwares"],
        url: "/admin/firmwares",
        subIcon: "/images/code-box-line.svg",
        activeIcon: "/images/code-box-line-(1).svg",
        collapse: false,
      },
      {
        label: "OTA",
        activeRoutes: ["/admin/OTAs"],
        url: "/admin/OTAs",
        subIcon: "/images/device-recover-line.svg",
        activeIcon: "/images/device-recover-line(1).svg",
        collapse: false,
      },
      {
        label: "OTA History",
        activeRoutes: ["/admin/OTA_History"],
        url: "/admin/OTA_History",
        subIcon: "/images/history-line.svg",
        activeIcon: "/images/history-line-(1).svg",
        collapse: false,
      },
      {
        label: "Rules",
        activeRoutes: ["/admin/rules"],
        url: "/admin/rules",
        subIcon: "/images/file-list-line.svg",
        activeIcon: "/images/file-list-line(1).svg",
        collapse: false,
      },
      {
        label: "Groups",
        activeRoutes: ["/admin/OTA-groups", "/admin/OTA-groups/:id"],
        url: "/admin/OTA-groups",
        subIcon: "/images/group-2-line.svg",
        activeIcon: "/images/group-2-line-(1).svg",
        collapse: false,
      },
    ],
  },
  {
    id: 5,
    label: "Slider",
    activeRoutes: ["/admin/safelink/slider"],
    url: "/admin/safelink/slider",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
];

export const airlinkRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/admin/dashboard"],
    url: "/admin/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: [
      "/admin/airlink/devices",
      "/admin/devices/view/:id",
      "/admin/device/view/firmware-history/:id",
      "/admin/device/view/impulse-rate-history/:id",
      "/admin/device/view/device-history/:id",
      "/admin/airlink/device/view/:id",
    ],
    url: "/admin/airlink/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
    collapse: false,
  },
  {
    id: 3,
    label: "Customers",
    activeRoutes: [
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
      "/admin/customer/trial/:id",
    ],
    url: "/admin/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },

  // {
  //   id: 4,
  //   label: 'Manage Agencies',
  //   activeRoutes: [
  //     '/admin/installer-agencies',
  //     '/admin/installer-agency',
  //     '/admin/installer-agency/view/:id',
  //     '/admin/installer-agency/:id',
  //     '/admin/integration/view/:id',
  //     '/admin/integrations'
  //   ],
  //   url: '/admin/installer-agencies',
  //   Icon: '/images/Manage-Agencies-icon.svg',
  //   activeIcon: '/images/Manage-Agencies-icon1.svg',
  //   collapse: true,
  //   subList: [
  //     {
  //       label: 'Integrations',
  //       activeRoutes: [
  //         '/admin/integrations',
  //         '/admin/integration/view/:id'
  //       ],
  //       url: '/admin/integrations',
  //       collapse: false,
  //       subIcon: '/images/team-line.svg',
  //       activeIcon: '/images/team-line(1).svg'

  //     },
  //     {
  //       label: 'Agencies',
  //       activeRoutes: [
  //         '/admin/installer-agencies',
  //         '/admin/installer-agency/view/:id',
  //         '/admin/installer-agency',
  //         '/admin/installer-agency/:id'
  //       ],
  //       url: '/admin/installer-agencies',
  //       subIcon: '/images/building-2-line.svg',
  //       activeIcon: '/images/building-2(1).svg',
  //       collapse: false
  //     }

  //   ]
  // },
  // {
  //   id: 6,
  //   label: 'Installer Agents',
  //   activeRoutes: [
  //     '/admin/installer-agents',
  //     '/admin/installer-agent/view/:id',
  //     '/admin/installer-agent/view/device/:id'
  //   ],
  //   url: '/admin/installer-agents',
  //   Icon: '/images/Installer-Agents-icon.svg',
  //   activeIcon: '/images/Installer-Agents-icon1.svg',
  //   collapse: false

  // },

  {
    id: 9,
    label: "Manage Firmwares",
    activeRoutes: [
      "/admin/firmwares",
      "/admin/OTAs",
      "/admin/OTA_History",
      "/admin/rules",
      "/admin/OTA-groups",
      "/admin/OTA-groups/:id",
    ],
    url: "/admin/firmwares",
    Icon: "/images/Manage-Firmwares.svg",
    activeIcon: "/images/Manage-Firmwares1.svg",
    collapse: true,
    subList: [
      {
        label: "Firmwares",
        activeRoutes: ["/admin/firmwares"],
        url: "/admin/firmwares",
        subIcon: "/images/code-box-line.svg",
        activeIcon: "/images/code-box-line-(1).svg",
        collapse: false,
      },
      {
        label: "OTA",
        activeRoutes: ["/admin/OTAs"],
        url: "/admin/OTAs",
        subIcon: "/images/device-recover-line.svg",
        activeIcon: "/images/device-recover-line(1).svg",
        collapse: false,
      },
      {
        label: "OTA History",
        activeRoutes: ["/admin/OTA_History"],
        url: "/admin/OTA_History",
        subIcon: "/images/history-line.svg",
        activeIcon: "/images/history-line-(1).svg",
        collapse: false,
      },
      {
        label: "Rules",
        activeRoutes: ["/admin/rules"],
        url: "/admin/rules",
        subIcon: "/images/file-list-line.svg",
        activeIcon: "/images/file-list-line(1).svg",
        collapse: false,
      },
      {
        label: "Groups",
        activeRoutes: ["/admin/OTA-groups", "/admin/OTA-groups/:id"],
        url: "/admin/OTA-groups",
        subIcon: "/images/group-2-line.svg",
        activeIcon: "/images/group-2-line-(1).svg",
        collapse: false,
      },
    ],
  },
  {
    id: 5,
    label: "Slider",
    activeRoutes: ["/admin/airlink/slider"],
    url: "/admin/airlink/slider",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
];

export const agencyRoutes = [
  {
    id: 1,
    label: "Devices",
    activeRoutes: ["/agency/devices", "/agency/heat_pump/device/view/:id"],
    url: "/agency/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
  },
  {
    id: 2,
    label: "Manage Electricians",
    activeRoutes: [
      "/agency/electricians",
      "/agency/electrician/view/:id",
      "/agency/electricians-agents",
      "/agency/electricians-agent/view/:id",
      "/agency/dataforce-devices",
      "/agency/dataforce-device/:id",
    ],
    Icon: "/images/Manage-Electricians.svg",
    activeIcon: "/images/Manage-Electricians1.svg",
    collapse: true,
    subList: [
      {
        label: "Electrician",
        activeRoutes: ["/agency/electricians", "/agency/electrician/view/:id"],
        url: "/agency/electricians",
        collapse: false,
        subIcon: "/images/Electrician.svg",
        activeIcon: "/images/Electrician1.svg",
      },
      {
        label: "Field Workers",
        activeRoutes: ["/agency/electricians-agents", "/agency/electricians-agent/view/:id"],
        url: "/agency/electricians-agents",
        subIcon: "/images/ElecInstallers.svg",
        activeIcon: "/images/ElecInstallers1.svg",
        collapse: false,
      },
      {
        label: "Devices - VEU",
        activeRoutes: ["/agency/dataforce-devices", "/agency/dataforce-device/:id"],
        url: "/agency/dataforce-devices",
        subIcon: "/images/Devices-icon.svg",
        activeIcon: "/images/Devices-icon1.svg",
        collapse: false,
      },
    ],
  },
  {
    id: 3,
    label: "Installer Agents",
    activeRoutes: [
      "/agency/installation-agents",
      "/agency/installation-agent",
      "/agency/installation-agent/view/:id",
      "/agency/installation-agent/:id",
    ],
    url: "/agency/installation-agents",
    Icon: "/images/Installer-Agents-icon.svg",
    activeIcon: "/images/Installer-Agents-icon1.svg",
  },
  // {
  //   id: 4,
  //   label: 'Profile',
  //   activeRoutes: ['/agency/profile'],
  //   url: '/agency/profile',
  //   Icon: '/images/Profile-icon.svg',
  //   activeIcon: '/images/Profile-icon-white.svg',
  // },
];

export const agencyHeatPumpRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/agency/dashboard"],
    url: "/agency/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: ["/agency/devices", "/agency/heat_pump/device/view/:id"],
    url: "/agency/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
  },
  {
    id: 5,
    label: "Attention",
    url: "/agency/heat_pump/faulty-systems",
    activeRoutes: [
      "/agency/heat_pump/faulty-systems",
      "/agency/heat_pump/faulty-systems/view/faulty-history/:id",
    ],
    Icon: "/images/faultysystem.png",
    activeIcon: "/images/faultysystem.svg",
    collapse: false,
    divider: true,
  },

  {
    id: 4,
    label: "Multi-Site Companies",
    url: "/agency/heat_pump/multi-site",
    activeRoutes: [
      "/agency/heat_pump/multi-site",
      "/agency/heat_pump/multi-site/:id",
      "/agency/heat_pump/multi-site-company/view/:id",
    ],
    Icon: "/images/Multisite-icon.svg",
    activeIcon: "/images/Multisite-active-icon.svg",
    collapse: false,
  },
  {
    id: 56,
    label: "Installer Agents",
    activeRoutes: [
      "/agency/installation-agents",
      "/agency/installation-agent",
      "/agency/installation-agent/view/:id",
      "/agency/installation-agent/:id",
    ],
    url: "/agency/installation-agents",
    Icon: "/images/Installer-Agents-icon.svg",
    activeIcon: "/images/Installer-Agents-icon1.svg",
  },

  {
    id: 6,
    label: "Customers",
    activeRoutes: [
      "/agency/customers",
      "/agency/customer/view/:id",
      "/agency/customer/customer-email-history/:id",
      "/agency/customer/property/view/:id",
      "/agency/customer/property/view-history/:id",
      "/agency/customer/property/property-timeline/:id",
      "/agency/customer/auto-sync/:id",
    ],
    url: "/agency/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },

  // {
  //   id: 5,
  //   label: 'Sites',
  //   activeRoutes: ['/agency/customer/sites'],
  //   url: '/agency/customer/sites',
  //   Icon: '/images/sites.png',
  //   activeIcon: '/images/sites-active.svg',
  //   collapse: false
  // },
];

export const electricianRoutes = [
  {
    id: 8,
    label: "Devices",
    activeRoutes: ["/electrician/devices", "/electrician/device/view/:id"],
    url: "/electrician/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
  },
  {
    id: 9,
    label: "Installer Agents",
    activeRoutes: [
      "/electrician/installer-agents",
      "/electrician/installer-agent",
      "/electrician/installer-agent/view/:id",
      "/electrician/installer-agent/:id",
    ],
    url: "/electrician/installer-agents",
    Icon: "/images/ElecInstallers.svg",
    activeIcon: "/images/ElecInstallers1.svg",
  },
  // {
  //   id: 10,
  //   label: 'Profile',
  //   activeRoutes: ['/electrician/profile'],
  //   url: '/electrician/profile',
  //   Icon: '/images/Profile-icon.svg',
  //   activeIcon: '/images/Profile-icon-white.svg',
  // },
];

export const SiteManagerRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/sitemanager/dashboard"],
    url: "/sitemanager/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: ["/sitemanager/devices", "/sitemanager/device/view/:id"],
    url: "/sitemanager/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
  },
  {
    id: 3,
    label: "Sites",
    activeRoutes: ["/sitemanager/sites", "/sitemanager/sites/view/:id"],
    url: "/sitemanager/sites",
    Icon: "/images/Sites-icon.svg",
    activeIcon: "/images/Sites-active-icon.svg",
  },
  {
    id: 4,
    label: "Attention",
    url: "/sitemanager/faulty-systems",
    activeRoutes: [
      "/sitemanager/faulty-systems",
      "/sitemanager/faulty-systems/view/faulty-history/:id",
    ],
    Icon: "/images/faultysystem.png",
    activeIcon: "/images/faultysystem.svg",
    faultIcon: "/images/faulty-alert-system.svg",
    collapse: false,
    divider: true,
  },
  {
    id: 5,
    label: "Customers",
    activeRoutes: [
      "/sitemanager/customers",
      "/sitemanager/customer/view/:id",
      "/sitemanager/customer/customer-email-history/:id",
      "/sitemanager/customer/property/view/:id",
      "/sitemanager/customer/property/view-history/:id",
      "/sitemanager/customer/property/property-timeline/:id",
      "/sitemanager/customer/auto-sync/:id",
    ],
    url: "/sitemanager/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },
  {
    id: 6,
    label: "Site Managers",
    activeRoutes: ["/sitemanager/site-managers", "/sitemanager/site-managers/view/:id"],
    url: "/sitemanager/site-managers",
    Icon: "/images/site-manager.svg",
    activeIcon: "/images/site-manager.svg",
  },
];

export const MultiSiteRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/agency/dashboard", "/multisite/dashboard"],
    url: "/multisite/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: ["/multisite/devices", "/multisite/device/view/:id"],
    url: "/multisite/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
  },
  {
    id: 3,
    label: "Sites",
    activeRoutes: ["/multisite/sites"],
    url: "/multisite/sites",
    Icon: "/images/Sites-icon.svg",
    activeIcon: "/images/Sites-active-icon.svg",
  },
  {
    id: 4,
    label: "Attention",
    url: "/multisite/faulty-systems",
    activeRoutes: [
      "/multisite/faulty-systems",
      "/multisite/faulty-systems/view/faulty-history/:id",
    ],
    Icon: "/images/faultysystem.png",
    activeIcon: "/images/faultysystem.svg",
    faultIcon: "/images/faulty-alert-system.svg",
    collapse: false,
    divider: true,
  },
  {
    id: 5,
    label: "Customers",
    activeRoutes: [
      "/multisite/customers",
      "/admin/customers",
      "/admin/customer/view/:id",
      "/admin/customer/customer-email-history/:id",
      "/admin/customer/property/view/:id",
      "/admin/customer/property/view-history/:id",
      "/admin/customer/property/property-timeline/:id",
      "/admin/customer/auto-sync/:id",
    ],
    url: "/multisite/customers",
    Icon: "/images/Customers-icon.svg",
    activeIcon: "/images/Customers-icon-(1).svg",
    collapse: false,
  },
  {
    id: 6,
    label: "Multi Site Contacts",
    activeRoutes: ["/multisite/contacts"],
    url: "/multisite/contacts",
    Icon: "/images/multi-site-contacts.svg",
    activeIcon: "/images/multi-site-contacts.svg",
  },
  {
    id: 7,
    label: "Site Managers",
    activeRoutes: ["/multisite/site-managers"],
    url: "/multisite/site-managers",
    Icon: "/images/site-manager.svg",
    activeIcon: "/images/site-manager.svg",
  },
];

export const sitesRoutes = [
  {
    id: 1,
    label: "Dashboard",
    activeRoutes: ["/sites/dashboard"],
    url: "/sites/dashboard",
    Icon: "/images/dashboard-icon-(1).svg",
    activeIcon: "/images/dashboard-icon.svg",
    collapse: false,
  },
  {
    id: 2,
    label: "Devices",
    activeRoutes: ["/sites/devices"],
    url: "/sites/devices",
    Icon: "/images/Devices-icon.svg",
    activeIcon: "/images/Devices-icon1.svg",
  },
  // {
  //   id: 3,
  //   label: 'Customers',
  //   activeRoutes: [
  //     '/agency/customers',
  //     '/agency/customer/view/:id',
  //     '/agency/customer/customer-email-history/:id',
  //     '/agency/customer/property/view/:id',
  //     '/agency/customer/property/view-history/:id',
  //     '/agency/customer/property/property-timeline/:id',
  //     '/agency/customer/auto-sync/:id'
  //   ],
  //   url: '/agency/customers',
  //   Icon: '/images/Customers-icon.svg',
  //   activeIcon: '/images/Customers-icon-(1).svg',
  //   collapse: false
  // },
  // {
  //   id: 4,
  //   label: 'Attention',
  //   url: '/agency/heat_pump/faulty-systems',
  //   activeRoutes: ['/agency/heat_pump/faulty-systems',
  //     '/agency/heat_pump/faulty-systems/view/faulty-history/:id'
  //   ],
  //   Icon: '/images/faultysystem.png',
  //   activeIcon: '/images/faultysystem.svg',
  //   collapse: false
  // },
  // {
  //   id: 5,
  //   label: 'Installer Agents',
  //   activeRoutes: [
  //     '/agency/installation-agents',
  //     '/agency/installation-agent',
  //     '/agency/installation-agent/view/:id',
  //     '/agency/installation-agent/:id'
  //   ],
  //   url: '/agency/installation-agents',
  //   Icon: '/images/Installer-Agents-icon.svg',
  //   activeIcon: '/images/Installer-Agents-icon1.svg',
  // },
  // {
  //   id: 5,
  //   label: 'Sites',
  //   activeRoutes: ['/agency/customer/sites'],
  //   url: '/agency/customer/sites',
  //   Icon: '/images/sites.png',
  //   activeIcon: '/images/sites-active.svg',
  //   collapse: false
  // },
];

export const colors = {
  primary: "#00a88e",
  secondary: "#4c6072",
  // "text-main": '#333333',
  // "border-main": '#4c607233',
  // "bg-light": '#f6f8fa',
  // "text-error": '#f00',
  // "success-text": '#008000',
  // "color-white": '#fff',
};

export const unitType = [
  "Apartment",
  "Cottage",
  "Factory",
  "Flat",
  "House",
  "Office",
  "Room",
  "Shed",
  "Shop",
  "Showroom",
  "Site",
  "Suite",
  "Townhouse",
  "Unit",
  "Villa",
];

export const streetType = [
  "Access",
  "Alley",
  "Alleyway",
  "Amble",
  "Anchorage",
  "Approach",
  "Arcade",
  "Artery",
  "Avenue",
  "Bank",
  "Basin",
  "Bay",
  "Beach",
  "Bend",
  "Block",
  "Boulevard",
  "Boundary",
  "Bowl",
  "Brace",
  "Brae",
  "Branch",
  "Break",
  "Bridge",
  "Broadway",
  "Brow",
  "Bypass",
  "Byway",
  "Causeway",
  "Centre",
  "Centreway",
  "Chase",
  "Circle",
  "Circlet",
  "Circuit",
  "Circus",
  "Close",
  "Colonnade",
  "Common",
  "Community",
  "Concourse",
  "Connection",
  "Copse",
  "Corner",
  "Corso",
  "Course",
  "Court",
  "Courtyard",
  "Cove",
  "Creek",
  "Crescent",
  "Crest",
  "Crief",
  "Cross",
  "Crossing",
  "Crossroad",
  "Crossway",
  "Cruiseway",
  "Cul De Sac",
  "Cutting",
  "Dale",
  "Dell",
  "Deviation",
  "Dip",
  "Distributor",
  "Downs",
  "Drive",
  "Driveway",
  "Easement",
  "Edge",
  "Elbow",
  "End",
  "Entrance",
  "Esplanade",
  "Estate",
  "Expressway",
  "Extension",
  "Fair",
  "Fairway",
  "Fire Track",
  "Firetrail",
  "Flat",
  "Follow",
  "Footway",
  "Foreshore",
  "Formation",
  "Freeway",
  "Front",
  "Frontage",
  "Gap",
  "Garden",
  "Gardens",
  "Gate",
  "Gates",
  "Gateway",
  "Glade",
  "Glen",
  "Grange",
  "Green",
  "Ground",
  "Grove",
  "Gully",
  "Heath",
  "Heights",
  "Highroad",
  "Highway",
  "Hill",
  "Hillside",
  "Interchange",
  "Intersection",
  "Island",
  "Junction",
  "Key",
  "Knoll",
  "Landing",
  "Lane",
  "Laneway",
  "Lees",
  "Line",
  "Link",
  "Little",
  "Location",
  "Lookout",
  "Loop",
  "Lower",
  "Mall",
  "Meander",
  "Mew",
  "Mews",
  "Motorway",
  "Mount",
  "Nook",
  "Outlook",
  "Parade",
  "Paradise",
  "Park",
  "Parklands",
  "Parkway",
  "Part",
  "Pass",
  "Path",
  "Pathway",
  "Piazza",
  "Pier",
  "Place",
  "Plateau",
  "Plaza",
  "Pocket",
  "Point",
  "Port",
  "Promenade",
  "Pursuit",
  "Quad",
  "Quadrangle",
  "Quadrant",
  "Quay",
  "Quays",
  "Racecourse",
  "Railway Siding",
  "Ramble",
  "Ramp",
  "Range",
  "Reach",
  "Reserve",
  "Rest",
  "Retreat",
  "Return",
  "Ride",
  "Ridge",
  "Ridgeway",
  "Right Of Way",
  "Ring",
  "Rise",
  "River",
  "Riverway",
  "Riviera",
  "Road",
  "Roads",
  "Roadside",
  "Roadway",
  "Ronde",
  "Rosebowl",
  "Rotary",
  "Round",
  "Route",
  "Row",
  "Rowe",
  "Rue",
  "Run",
  "Service Way",
  "Siding",
  "Slope",
  "Sound",
  "Spur",
  "Square",
  "Stairs",
  "State Highway",
  "Station",
  "Steps",
  "Straight",
  "Strand",
  "Street",
  "Strip",
  "Subway",
  "Tarn",
  "Terrace",
  "Thoroughfare",
  "Tollway",
  "Top",
  "Tor",
  "Tower",
  "Towers",
  "Track",
  "Trail",
  "Trailer",
  "Triangle",
  "Trunkway",
  "Turn",
  "Underpass",
  "Upper",
  "Vale",
  "Viaduct",
  "View",
  "Village",
  "Villas",
  "Vista",
  "Wade",
  "Walk",
  "Walkway",
  "Waters",
  "Way",
  "Wharf",
  "Wood",
  "Wynd",
  "Yard",
];

export const levelType = ["Block", "Floor", "Level", "Lot"];

export const addressType = ["Residential", "Commercial"];

export const state = ["NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA", "ACT"];

export const streetTypeSuffix = [
  "Central",
  "East",
  "Extension",
  "Lower",
  "North",
  "North East",
  "North West",
  "South",
  "South East",
  "South West",
  "Upper",
  "West",
];

export const paginationList = [
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "200", value: 200 },
  { label: "500", value: 500 },
];

export const activityStatusList = [
  { value: "all", label: "All Status" },
  { value: "on", label: "On" },
  { value: "off", label: "Off" },
  { value: "temperature", label: "Temperature" },
  { value: "boost_mode", label: "Boost Mode" },
  { value: "silent_mode", label: "Silent Mode" },
  { value: "standard_mode", label: "Standard Mode" },
  { value: "smart_action", label: "Smart Actions" },
  { value: "heating", label: "Heating" },
  { value: "heating_completed", label: "Heating Completed" },
  { value: "fault", label: "Fault" },
];

export const passwordRegValidationKey = {
  noUpperCase: true,
  noLowerCase: true,
  noDigit: true,
  noLength: true,
};

export const phoneRegex = /^[+\d](?:.*\d)?$/;

export const lettersAndDigitsRegex = /^[a-zA-Z0-9_.-]*$/;

export const onlyNumberRegex = /^[0-9]+$/;

export const numberAndDecimalRegex = /^[0-9]+\.?[0-9]*$/;

export const urlPattern = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

export function bytesToMegaBytes(bytes) {
  return bytes / (1024 * 1024);
}

export function abbreviateNumber(num, digits) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}

export const heatpumpDeviceTableHeadAdmin = [
  {
    id: "serial_number",
    sortByKey: "serial_number",
    label: "Serial Number",
    className: "show-pointer",
  },
  { id: "mac_address", sortByKey: "mac_address", label: "MAC Address", className: "show-pointer" },
  { id: "postal_code", sortByKey: "postal_code", label: "Address", className: "show-pointer" },
  {
    id: "soft_version",
    sortByKey: "soft_version",
    label: "Firmware Version",
    className: "show-pointer",
  },
  { id: "wifi_name", sortByKey: "wifi_name", label: "WiFi Name", className: "show-pointer" },
  { id: "model_name", sortByKey: "model_name", label: "Model Name", className: "show-pointer" },
  { id: "series_type", sortByKey: "series_type", label: "Series Type", className: "show-pointer" },
  { id: "is_qr", sortByKey: "is_qr", label: "QR Code", className: "show-pointer" },
  {
    id: "installation_date",
    sortByKey: "installation_date",
    label: "Installation Date",
    className: "show-pointer",
  },

  { id: "agency_name", sortByKey: "agency_name", label: "Agency Name", className: "show-pointer" },
  { id: "agent_name", sortByKey: "agent_name", label: "Agent Name", className: "show-pointer" },
  {
    id: "company_name",
    sortByKey: "company_name",
    label: "Multi Site Company Name",
    className: "show-pointer",
  },
  { id: "site_name", sortByKey: "site_name", label: "Site Name", className: "show-pointer" },
  {
    id: "wifi_signal",
    sortByKey: "action",
    label: "Wi-Fi Signal Strength",
    className: "show-pointer",
  },
  {
    id: "status",
    sortByKey: "status",
    label: "Customer State",
    className: "show-pointer",
    isMore: true,
  },
  {
    id: "is_online",
    sortByKey: "is_online",
    label: "Device Wi-Fi Status",
    className: "show-pointer",
  },
  {
    id: "heatpump_device_status",
    sortByKey: "action",
    label: "Device Operation Status",
    className: "show-pointer",
    isMore: true,
  },
  {
    id: "connection_type",
    sortByKey: "connection_type",
    label: "Connection Type",
    className: "show-pointer",
  },
  { id: "id", sortByKey: "id", label: "Record ID", className: "show-pointer" },
  { id: "device_tags", sortByKey: "device_tags", label: "Tags", className: "show-pointer" },
  { id: "action", sortByKey: "action", label: "Action", stickyClassName: "more" },
];

export const heatpumpDeviceTableHeadAgency = [
  {
    id: "serial_number",
    sortByKey: "serial_number",
    label: "Serial Number",
    className: "show-pointer",
  },
  { id: "mac_address", sortByKey: "mac_address", label: "MAC Address", className: "show-pointer" },
  { id: "postal_code", sortByKey: "postal_code", label: "Address", className: "show-pointer" },
  {
    id: "soft_version",
    sortByKey: "soft_version",
    label: "Firmware Version",
    className: "show-pointer",
  },
  { id: "wifi_name", sortByKey: "wifi_name", label: "WiFi Name", className: "show-pointer" },
  { id: "model_name", sortByKey: "model_name", label: "Model Name", className: "show-pointer" },
  {
    id: "installation_date",
    sortByKey: "installation_date",
    label: "Installation Date",
    className: "show-pointer",
  },

  { id: "agent_name", sortByKey: "agent_name", label: "Agent Name", className: "show-pointer" },
  {
    id: "company_name",
    sortByKey: "company_name",
    label: "Multi Site Company Name",
    className: "show-pointer",
  },
  { id: "site_name", sortByKey: "site_name", label: "Site Name", className: "show-pointer" },
  {
    id: "wifi_signal",
    sortByKey: "action",
    label: "Wi-Fi Signal Strength",
    className: "show-pointer",
  },
  {
    id: "status",
    sortByKey: "status",
    label: "Customer State",
    className: "show-pointer",
    isMore: true,
  },
  {
    id: "is_online",
    sortByKey: "is_online",
    label: "Device Wi-Fi Status",
    className: "show-pointer",
  },
  {
    id: "heatpump_device_status",
    sortByKey: "action",
    label: "Device Operation Status",
    className: "show-pointer",
    isMore: true,
  },
  { id: "action", sortByKey: "action", label: "Action", stickyClassName: "more" },
];

export const heatpumpDeviceTableHeadMsc = [
  {
    id: "serial_number",
    sortByKey: "serial_number",
    label: "Serial Number",
    className: "show-pointer",
  },
  { id: "mac_address", sortByKey: "mac_address", label: "MAC Address", className: "show-pointer" },
  { id: "postal_code", sortByKey: "postal_code", label: "Address", className: "show-pointer" },
  {
    id: "soft_version",
    sortByKey: "soft_version",
    label: "Firmware Version",
    className: "show-pointer",
  },
  { id: "wifi_name", sortByKey: "wifi_name", label: "WiFi Name", className: "show-pointer" },
  { id: "model_name", sortByKey: "model_name", label: "Model Name", className: "show-pointer" },
  {
    id: "installation_date",
    sortByKey: "installation_date",
    label: "Installation Date",
    className: "show-pointer",
  },

  { id: "agency_name", sortByKey: "agency_name", label: "Agency Name", className: "show-pointer" },
  { id: "agent_name", sortByKey: "agent_name", label: "Agent Name", className: "show-pointer" },
  { id: "site_name", sortByKey: "site_name", label: "Site Name", className: "show-pointer" },
  {
    id: "wifi_signal",
    sortByKey: "action",
    label: "Wi-Fi Signal Strength",
    className: "show-pointer",
  },
  {
    id: "status",
    sortByKey: "status",
    label: "Customer State",
    className: "show-pointer",
    isMore: true,
  },
  {
    id: "is_online",
    sortByKey: "is_online",
    label: "Device Wi-Fi Status",
    className: "show-pointer",
  },
  {
    id: "heatpump_device_status",
    sortByKey: "action",
    label: "Device Operation Status",
    className: "show-pointer",
    isMore: true,
  },
  { id: "action", sortByKey: "action", label: "Action", stickyClassName: "more" },
];

export const heatpumpDeviceTableHeadSm = [
  {
    id: "serial_number",
    sortByKey: "serial_number",
    label: "Serial Number",
    className: "show-pointer",
  },
  { id: "mac_address", sortByKey: "mac_address", label: "MAC Address", className: "show-pointer" },
  { id: "postal_code", sortByKey: "postal_code", label: "Address", className: "show-pointer" },
  {
    id: "soft_version",
    sortByKey: "soft_version",
    label: "Firmware Version",
    className: "show-pointer",
  },
  { id: "wifi_name", sortByKey: "wifi_name", label: "WiFi Name", className: "show-pointer" },
  { id: "model_name", sortByKey: "model_name", label: "Model Name", className: "show-pointer" },
  {
    id: "installation_date",
    sortByKey: "installation_date",
    label: "Installation Date",
    className: "show-pointer",
  },

  {
    id: "company_name",
    sortByKey: "company_name",
    label: "Multi Site Company Name",
    className: "show-pointer",
  },
  { id: "site_name", sortByKey: "site_name", label: "Site Name", className: "show-pointer" },
  {
    id: "wifi_signal",
    sortByKey: "action",
    label: "Wi-Fi Signal Strength",
    className: "show-pointer",
  },
  {
    id: "status",
    sortByKey: "status",
    label: "Customer State",
    className: "show-pointer",
    isMore: true,
  },
  {
    id: "is_online",
    sortByKey: "is_online",
    label: "Device Wi-Fi Status",
    className: "show-pointer",
  },
  {
    id: "heatpump_device_status",
    sortByKey: "action",
    label: "Device Operation Status",
    className: "show-pointer",
    isMore: true,
  },
  { id: "action", sortByKey: "action", label: "Action", stickyClassName: "more" },
];

export const cloudToolCommands = {
  "gateway-info": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "config",
        "hw_id": "{mac_address}",
        "msg_id": "{Random Integer}",
        "command": "dev_info",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      {}
    ]
  },
  "complete-query": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "business",
        "hw_id": "{mac_address}",
        "msg_id": "{Random Integer}",
        "command": "comp_query",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      {}
    ],
  },
  "turn-on-off": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "business",
        "msg_id": "{Random Integer}",
        "command": "control",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      { "switch": "{switch_value}" }
    ],
  },
  "set-modes": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "business",
        "msg_id": "{Random Integer}",
        "command": "control",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      { "mode": "{modes_value}" }
    ],
  },
  "set-temperature": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "business",
        "hw_id": "{mac_address}",
        "msg_id": "{Random Integer}",
        "command": "control",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      {
        "temp_set": "{temperature_value}"
      }
    ],
  },
  "firmware-upgrade": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "config",
        "hw_id": "{mac_address}",
        "msg_id": "{Random Integer}",
        "command": "ota_start",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      {
        "url": "{ota_url}",
        "md5": "{md5value}"
      }
    ],
  },
  "disinfection": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "business",
        "msg_id": "{Random Integer}",
        "command": "control",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      { "disinfection": "{disinfection_value}" }
    ],
  },
  "param-active-query": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "namespace": "business",
        "msg_id": "{Random Integer}",
        "command": "param_active_query",
        "property_id": "{property_id}",
        "direction": "app2gw"
      },
      {}
    ],
  },
  "custom-command": {
    topic: "ep/heat_pump/to_gw/{device_id}",
    packet: [
      {
        "device_id": "{device_id}",
        "hw_id": "{mac_address}",
        "msg_id": "{Random Integer}",
        "property_id": "{property_id}",
        "direction": "app2gw",
        "namespace": "",
        "command": ""
      },
      {}
    ],
  },
}
